<!-- @todo Factoriser avec les autres graphes -->
<svg class="diag-graphe-v2-consommation" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 330 260">
    <defs>
        <style>
            .diag-graphe-v2-consommation .a {
                fill: #00a06d;
            }

            .diag-graphe-v2-consommation .b {
                fill: #52b153;
            }

            .diag-graphe-v2-consommation .c {
                fill: #a5cc74;
            }

            .diag-graphe-v2-consommation .d {
                fill: #f4e70f;
            }

            .diag-graphe-v2-consommation .e {
                fill: #f0b40f;
            }

            .diag-graphe-v2-consommation .f {
                fill: #eb8235;
            }

            .diag-graphe-v2-consommation .g {
                fill: #d7221f;
            }

            .diag-graphe-v2-consommation .passoire {
                fill: none;
                stroke: #9d9d9c;
                stroke-width: 1.5px;
            }

            .diag-graphe-v2-consommation .white {
                fill: #fff;
            }
        </style>
    </defs>

    <title>Performance énergétique</title>

    <!-- A -->
    <text x="110" y="39" class="a" font-size="8" font-weight="bold">logement extrêmement performant</text>
    <polygon class="a" points="175 67 111 67 111 43 175 43 183 55 175 67"/>
    <path class="white"
          d="M126.52,62.22l-1-3.33h-4.67l-1,3.33h-3.08l4.6-14h3.77l4.54,14ZM123.21,51h-.1l-1.53,5.3h3.2Z"/>

    <!-- B -->
    <polygon class="b" points="192 94 111 94 111 71 192 71 200 83 192 94"/>
    <path class="white"
          d="M118.1,75.81h6.78a3.38,3.38,0,0,1,3.68,3.58c0,2.14-1.18,2.94-2.6,3v.12a3.09,3.09,0,0,1,3.14,3.28,3.76,3.76,0,0,1-3.6,4h-7.4Zm3,5.72h3a1.18,1.18,0,0,0,1.28-1.28v-.6a1.18,1.18,0,0,0-1.28-1.28h-3Zm0,5.68h3.5a1.18,1.18,0,0,0,1.3-1.26v-.68a1.18,1.18,0,0,0-1.3-1.26h-3.5Z"/>

    <!-- C -->
    <polygon class="c" points="210 121 111 121 111 97 210 97 218 109 210 121"/>
    <path class="white"
          d="M117.72,109.09c0-4.72,2.42-7.32,6.18-7.32a5.17,5.17,0,0,1,5.22,3.28l-2.62,1.36a2.47,2.47,0,0,0-2.6-1.94c-1.78,0-3,1.2-3,3.4v2.24c0,2.2,1.18,3.4,3,3.4a2.87,2.87,0,0,0,2.78-2.08l2.48,1.44a5.46,5.46,0,0,1-5.26,3.34C120.14,116.21,117.72,113.81,117.72,109.09Z"/>

    <!-- D -->
    <polygon class="d" points="228 148 111 148 111 124 228 124 236 136 228 148"/>
    <path class="white"
          d="M117.8,128.7h5.26c3.7,0,6.14,2.34,6.14,7s-2.44,7-6.14,7H117.8ZM123.06,140c1.8,0,2.92-1,2.92-3.2V134.6c0-2.22-1.12-3.2-2.92-3.2h-2.22V140Z"/>

    <!-- E -->
    <polygon class="e" points="246 174 111 174 111 151 246 151 254 163 246 174"/>
    <path class="white" d="M118.7,169.52v-14h9.5v2.7h-6.46v2.86h5.54v2.68h-5.54v3h6.46v2.7Z"/>

    <!-- F -->
    <polygon class="f" points="264 201 111 201 111 178 264 178 272 189 264 201"/>
    <path class="white" d="M118.92,195.94V182h9.26v2.7H122v2.86h5.3v2.68H122v5.72Z"/>

    <!-- G -->
    <polygon class="g" points="283 228 111 228 111 204 283 204 291 216 283 228"/>
    <path class="white"
          d="M126.44,220.73h-.1c-.2,1.4-1.48,2.46-3.58,2.46-3.2,0-5.72-2.48-5.72-7.16s2.54-7.28,6.32-7.28a5.59,5.59,0,0,1,5.38,3.24l-2.48,1.42a2.89,2.89,0,0,0-2.9-2c-1.88,0-3.1,1.08-3.1,3.4v2.24c0,2.32,1.22,3.4,3.1,3.4,1.52,0,2.74-.72,2.74-2.08v-.7h-2.6v-2.54H129V223h-2.56Z"/>
    <text x="110" y="238" class="g" font-size="8" font-weight="bold">logement extrêmement peu performant</text>

    <!-- Passoire énergétique -->
    <line class="passoire" x1="106" y1="178" x2="106" y2="228"/>
    <g transform="translate(100,200)" font-size="7" font-weight="bold" fill="#9d9d9c" text-anchor="end">
        <text x="0" y="0">passoire</text>
        <text x="0" y="8">énergétique</text>
    </g>
</svg>
